import React from "react";
import { TouchableRipple } from "react-native-paper";
import { convertHexToRGBA } from "../../../utils/general";
import { Platform, View, StyleSheet } from "react-native";
import {Text, theme, typography} from "ui-components"
import { deriveUnitTitle, getPropertyAddressFromPropertyProfile } from "../../../screens/new/utils/helper";
import { DomusoPropertyProfile } from "../../../../types/db-types";
import automationTestingLocators from "../../../screens/new/utils/automation-testing-locators.json"
interface SingleReservation {
    accounting_details: any;
    account_system_type: any;
    property_unit: string;
    prop_name: string;
    prop_id: string;
    balance_due: string;
    allowed_payments: "ANY" | "DO_NOT_ACCEPT_PAYMENT" | "CASH_EQUIVALENT";
    accounting_id: string;
    yardi_id: string;
    id: string;
    status: string;
    is_blacklisted: boolean;
    is_blocked: boolean;
    isPaymentEnabled: boolean;
    index: number;
    selectedReservation?: number;
    reservationsLength: number;
    property_profile: DomusoPropertyProfile;
    onOptionSelected: any;
    accordionId?: string
}
export const ReservationOptions = (props: SingleReservation) => {
    const {index, selectedReservation, id, reservationsLength, property_unit, prop_name, property_profile, onOptionSelected} = props
    return ( 
        <TouchableRipple 
            rippleColor={Platform.OS == "web" ?  convertHexToRGBA(theme.colors.filter, 0.4) : convertHexToRGBA(theme.colors.filter, 0.9)}
            key={id || index} 
            style={{
                flex:1,
                padding:10, 
                borderBottomWidth: index+1 < reservationsLength ? 0.2 : 0, 
                borderColor: theme.colors.stroke,
                backgroundColor: selectedReservation == index ? theme.colors.filter : theme.colors.white,
                borderBottomLeftRadius: index+1 < reservationsLength ? 0 : 20,
                borderBottomRightRadius: index+1 < reservationsLength ? 0 : 20,
            }}
            onPress={() => { onOptionSelected(props) }}
            testID={automationTestingLocators.reservationAccordionOption.reservationOptionButton.testID + `-${id}`}
            accessibilityLabel={automationTestingLocators.reservationAccordionOption.reservationOptionButton.accessibilityLabel + ` ${id}`}
        >
            <>
                <View style={{ flexDirection: "row", alignItems: "flex-start", flex: 1 }}>
                    <Text style={[styles.propertyName, {flex:1}]} 
                    testID={automationTestingLocators.reservationAccordionOption.propertyNameAndUnit.testID + `-${id}`}
                    accessibilityLabel={automationTestingLocators.reservationAccordionOption.propertyNameAndUnit.accessibilityLabel + ` ${id}`}
                    >
                        {`${prop_name}, ${deriveUnitTitle(property_unit)}`}
                    </Text>
                </View>
                <View>
                    <Text
                        style={[styles.propertyAddress]}
                        testID={automationTestingLocators.reservationAccordionOption.propertyAddress.testID + `-${id}`}
                        accessibilityLabel={automationTestingLocators.reservationAccordionOption.propertyAddress.accessibilityLabel + ` ${id}`}
                    >
                        {getPropertyAddressFromPropertyProfile(property_profile)}
                    </Text>
                </View>
            </>
        </TouchableRipple> 
    )
}

const styles = StyleSheet.create({
    propertyName: {
        ...typography.body,
        fontFamily: "Lato_700Bold",
        color: theme.colors.text4,
        flex:1
    },
    propertyAddress: {
        ...typography.body,
        fontWeight: "400",
        color: theme.colors.text2,
        flex:1
    },
})